import { Link, Outlet } from "@tanstack/react-router";

const TABS = [
  { to: "/admin", label: "Overview", exact: true },
  { to: "/admin/organizations", label: "Organizations" },
  { to: "/admin/users", label: "Users" },
  { to: "/admin/jobs", label: "Jobs" },
  { to: "/admin/plans", label: "Plans" },
  { to: "/admin/audit", label: "Audit log" },
] as const;

export function AdminLayout() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-lg font-semibold">Platform admin</h1>
        <p className="text-sm text-muted">
          Every tenant. Actions here are recorded in the audit log.
        </p>
      </div>

      <nav aria-label="Admin sections" className="flex gap-1 overflow-x-auto border-b border-line">
        {TABS.map((tab) => (
          <Link
            key={tab.to}
            to={tab.to}
            activeOptions={{ exact: "exact" in tab && tab.exact }}
            className="whitespace-nowrap border-b-2 border-transparent px-3 py-2 text-sm text-muted hover:text-ink"
            activeProps={{
              className:
                "whitespace-nowrap border-b-2 border-brand px-3 py-2 text-sm font-medium text-ink",
            }}
          >
            {tab.label}
          </Link>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
